// extracted by mini-css-extract-plugin
export var lightMode = "_f-0";